import consumer from "./consumer"

consumer.subscriptions.create("PricingRequestChannel", {
    connected() {
    },

    received(data) {
        if (data.status === 'accepted' || data.status === 'rejected') {
            const acceptButton = document.getElementById(`pricing-request-message-action-${data.deal_pricing_request_id}-accept`);
            const rejectButton = document.getElementById(`pricing-request-message-action-${data.deal_pricing_request_id}-reject`);

            acceptButton.disabled = true;
            rejectButton.disabled = true;
        }

        if (data.status === 'pricing_provided') {
            const infoButton = document.getElementById(`pricing-request-message-action-${data.deal_pricing_request_id}-add-information`);
            infoButton.disabled = true;
        }
    }
});
